/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Component } from '../models';
// @ts-ignore
import type { ComponentActionParams } from '../models';
// @ts-ignore
import type { ComponentActionResult } from '../models';
// @ts-ignore
import type { ComponentStatus } from '../models';
// @ts-ignore
import type { InstallOperatorResponse } from '../models';
// @ts-ignore
import type { InstalledComponent } from '../models';
// @ts-ignore
import type { RunComponentActionResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
// @ts-ignore
import type { ValidateComponentInstallRequest } from '../models';
// @ts-ignore
import type { ValidateComponentInstallResponse } from '../models';
// @ts-ignore
import type { ValidateComponentUpgradeRequest } from '../models';
// @ts-ignore
import type { ValidateComponentUpgradeResponse } from '../models';
// @ts-ignore
import type { ViewClusterComponentsResponse } from '../models';
// @ts-ignore
import type { ViewClustersComponentsResponse } from '../models';
// @ts-ignore
import type { ViewComponentResponse } from '../models';
// @ts-ignore
import type { ViewComponentsResponse } from '../models';
/**
 * ComponentsAPIApi - axios parameter creator
 * @export
 */
export const ComponentsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the CASTware operator onboarding script. All parameters, including the  API token, are passed via environment variables at runtime.  The flat /v1/scripts/... path mirrors connect-and-enable-castai.sh.
         * @summary Get the CASTware operator onboarding script.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIGetCastwareOperatorOnboardingScript: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/scripts/castware-operator/onboarding.sh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the component by name.  Used by the Castware Operator to validate the component CRD.
         * @summary Get a CASTware component by name.
         * @param {string} [name] Filters components by name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIGetComponentByName: async (name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cluster-management/v1/components:getByName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the status of a component for a cluster
         * @summary Get an installed CASTware component status.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} componentId The ID of the component.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIGetComponentStatus: async (organizationId: string, clusterId: string, componentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('componentsAPIGetComponentStatus', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('componentsAPIGetComponentStatus', 'clusterId', clusterId)
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('componentsAPIGetComponentStatus', 'componentId', componentId)
            const localVarPath = `/cluster-management/v1/organizations/{organizationId}/clusters/{clusterId}/components/{componentId}/status`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"componentId"}}`, encodeURIComponent(String(componentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the CASTware operator install command ready to be run on user cluster
         * @param {ComponentsAPIInstallOperatorProviderTypeEnum} [providerType] Provider of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIInstallOperator: async (providerType?: ComponentsAPIInstallOperatorProviderTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cluster-management/v1/components:installOperator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (providerType !== undefined) {
                localVarQueryParameter['providerType'] = providerType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Records the results of an action performed on a CASTware component.  Under the hood creates or updates an installed component.  Used by the Castware Operator to relay information about the result of an action.
         * @summary Record the result of an action performed on a CASTware component.
         * @param {string} clusterId The ID of the cluster.
         * @param {ComponentActionResult} componentActionResult 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIRecordActionResult: async (clusterId: string, componentActionResult: ComponentActionResult, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('componentsAPIRecordActionResult', 'clusterId', clusterId)
            // verify required parameter 'componentActionResult' is not null or undefined
            assertParamExists('componentsAPIRecordActionResult', 'componentActionResult', componentActionResult)
            const localVarPath = `/cluster-management/v1/clusters/{clusterId}/components:recordActionResult`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(componentActionResult, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Runs an action on an installed component, if the operator is installed the action is run automatically,  otherwise a bash script to run the action manually is returned
         * @summary Run an action for a CASTware component.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the component.
         * @param {ComponentActionParams} componentActionParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIRunComponentAction: async (organizationId: string, clusterId: string, id: string, componentActionParams: ComponentActionParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('componentsAPIRunComponentAction', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('componentsAPIRunComponentAction', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentsAPIRunComponentAction', 'id', id)
            // verify required parameter 'componentActionParams' is not null or undefined
            assertParamExists('componentsAPIRunComponentAction', 'componentActionParams', componentActionParams)
            const localVarPath = `/cluster-management/v1/organizations/{organizationId}/clusters/{clusterId}/components/{id}:runAction`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(componentActionParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates if a component installation can proceed based on operator RBAC permissions.
         * @summary Validate if component installation can proceed
         * @param {string} clusterId The cluster ID where the component will be installed.
         * @param {ValidateComponentInstallRequest} validateComponentInstallRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIValidateComponentInstall: async (clusterId: string, validateComponentInstallRequest: ValidateComponentInstallRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('componentsAPIValidateComponentInstall', 'clusterId', clusterId)
            // verify required parameter 'validateComponentInstallRequest' is not null or undefined
            assertParamExists('componentsAPIValidateComponentInstall', 'validateComponentInstallRequest', validateComponentInstallRequest)
            const localVarPath = `/cluster-management/v1/clusters/{clusterId}/components:validateInstallation`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateComponentInstallRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates if a component upgrade can proceed based on RBAC checksum changes.
         * @summary Validate if component upgrade can proceed
         * @param {string} clusterId The cluster ID where the component is installed.
         * @param {ValidateComponentUpgradeRequest} validateComponentUpgradeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIValidateComponentUpgrade: async (clusterId: string, validateComponentUpgradeRequest: ValidateComponentUpgradeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('componentsAPIValidateComponentUpgrade', 'clusterId', clusterId)
            // verify required parameter 'validateComponentUpgradeRequest' is not null or undefined
            assertParamExists('componentsAPIValidateComponentUpgrade', 'validateComponentUpgradeRequest', validateComponentUpgradeRequest)
            const localVarPath = `/cluster-management/v1/clusters/{clusterId}/components:validateUpgrade`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateComponentUpgradeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a view of a cluster combined with all CASTware components, for the given organization.  If a component is installed on the cluster, components insights are also provided.  It is a custom endpoint which combines clusters, components and installed components meant to be used by UI.
         * @summary View a cluster with installed CASTware components insights.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIViewClusterComponents: async (organizationId: string, clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('componentsAPIViewClusterComponents', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('componentsAPIViewClusterComponents', 'clusterId', clusterId)
            const localVarPath = `/cluster-management/v1/organizations/{organizationId}/clusters/{clusterId}/components:view`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a view of all clusters with CASTware components insights, for the given organization.  It is a custom endpoint which combines clusters, components and installed components meant to be used by UI.
         * @summary View clusters with CASTware components insights.
         * @param {string} organizationId The ID of the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIViewClustersComponents: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('componentsAPIViewClustersComponents', 'organizationId', organizationId)
            const localVarPath = `/cluster-management/v1/organizations/{organizationId}/components:viewClusters`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a view of a CASTware component combined with all clusters, for the given organization.  If the component is installed on a cluster, components insights are also provided.  It is a custom endpoint which combines components and installed components meant to be used by UI.
         * @summary View a CASTware component with installed components insights.
         * @param {string} organizationId The ID of the organization.
         * @param {string} id The ID of the component.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIViewComponent: async (organizationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('componentsAPIViewComponent', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentsAPIViewComponent', 'id', id)
            const localVarPath = `/cluster-management/v1/organizations/{organizationId}/components/{id}:view`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a view of all CASTware components with cluster insights, for the given organization.  It is a custom endpoint which combines components and installed components meant to be used by UI.
         * @summary View CASTware components with cluster insights.
         * @param {string} organizationId The ID of the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIViewComponents: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('componentsAPIViewComponents', 'organizationId', organizationId)
            const localVarPath = `/cluster-management/v1/organizations/{organizationId}/components:view`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComponentsAPIApi - functional programming interface
 * @export
 */
export const ComponentsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComponentsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the CASTware operator onboarding script. All parameters, including the  API token, are passed via environment variables at runtime.  The flat /v1/scripts/... path mirrors connect-and-enable-castai.sh.
         * @summary Get the CASTware operator onboarding script.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsAPIGetCastwareOperatorOnboardingScript(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsAPIGetCastwareOperatorOnboardingScript(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComponentsAPIApi.componentsAPIGetCastwareOperatorOnboardingScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets the component by name.  Used by the Castware Operator to validate the component CRD.
         * @summary Get a CASTware component by name.
         * @param {string} [name] Filters components by name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsAPIGetComponentByName(name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Component>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsAPIGetComponentByName(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComponentsAPIApi.componentsAPIGetComponentByName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets the status of a component for a cluster
         * @summary Get an installed CASTware component status.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} componentId The ID of the component.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsAPIGetComponentStatus(organizationId: string, clusterId: string, componentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsAPIGetComponentStatus(organizationId, clusterId, componentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComponentsAPIApi.componentsAPIGetComponentStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the CASTware operator install command ready to be run on user cluster
         * @param {ComponentsAPIInstallOperatorProviderTypeEnum} [providerType] Provider of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsAPIInstallOperator(providerType?: ComponentsAPIInstallOperatorProviderTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstallOperatorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsAPIInstallOperator(providerType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComponentsAPIApi.componentsAPIInstallOperator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Records the results of an action performed on a CASTware component.  Under the hood creates or updates an installed component.  Used by the Castware Operator to relay information about the result of an action.
         * @summary Record the result of an action performed on a CASTware component.
         * @param {string} clusterId The ID of the cluster.
         * @param {ComponentActionResult} componentActionResult 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsAPIRecordActionResult(clusterId: string, componentActionResult: ComponentActionResult, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstalledComponent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsAPIRecordActionResult(clusterId, componentActionResult, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComponentsAPIApi.componentsAPIRecordActionResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Runs an action on an installed component, if the operator is installed the action is run automatically,  otherwise a bash script to run the action manually is returned
         * @summary Run an action for a CASTware component.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the component.
         * @param {ComponentActionParams} componentActionParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsAPIRunComponentAction(organizationId: string, clusterId: string, id: string, componentActionParams: ComponentActionParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RunComponentActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsAPIRunComponentAction(organizationId, clusterId, id, componentActionParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComponentsAPIApi.componentsAPIRunComponentAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validates if a component installation can proceed based on operator RBAC permissions.
         * @summary Validate if component installation can proceed
         * @param {string} clusterId The cluster ID where the component will be installed.
         * @param {ValidateComponentInstallRequest} validateComponentInstallRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsAPIValidateComponentInstall(clusterId: string, validateComponentInstallRequest: ValidateComponentInstallRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateComponentInstallResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsAPIValidateComponentInstall(clusterId, validateComponentInstallRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComponentsAPIApi.componentsAPIValidateComponentInstall']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validates if a component upgrade can proceed based on RBAC checksum changes.
         * @summary Validate if component upgrade can proceed
         * @param {string} clusterId The cluster ID where the component is installed.
         * @param {ValidateComponentUpgradeRequest} validateComponentUpgradeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsAPIValidateComponentUpgrade(clusterId: string, validateComponentUpgradeRequest: ValidateComponentUpgradeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateComponentUpgradeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsAPIValidateComponentUpgrade(clusterId, validateComponentUpgradeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComponentsAPIApi.componentsAPIValidateComponentUpgrade']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets a view of a cluster combined with all CASTware components, for the given organization.  If a component is installed on the cluster, components insights are also provided.  It is a custom endpoint which combines clusters, components and installed components meant to be used by UI.
         * @summary View a cluster with installed CASTware components insights.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsAPIViewClusterComponents(organizationId: string, clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewClusterComponentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsAPIViewClusterComponents(organizationId, clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComponentsAPIApi.componentsAPIViewClusterComponents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets a view of all clusters with CASTware components insights, for the given organization.  It is a custom endpoint which combines clusters, components and installed components meant to be used by UI.
         * @summary View clusters with CASTware components insights.
         * @param {string} organizationId The ID of the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsAPIViewClustersComponents(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewClustersComponentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsAPIViewClustersComponents(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComponentsAPIApi.componentsAPIViewClustersComponents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets a view of a CASTware component combined with all clusters, for the given organization.  If the component is installed on a cluster, components insights are also provided.  It is a custom endpoint which combines components and installed components meant to be used by UI.
         * @summary View a CASTware component with installed components insights.
         * @param {string} organizationId The ID of the organization.
         * @param {string} id The ID of the component.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsAPIViewComponent(organizationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewComponentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsAPIViewComponent(organizationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComponentsAPIApi.componentsAPIViewComponent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets a view of all CASTware components with cluster insights, for the given organization.  It is a custom endpoint which combines components and installed components meant to be used by UI.
         * @summary View CASTware components with cluster insights.
         * @param {string} organizationId The ID of the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsAPIViewComponents(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewComponentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsAPIViewComponents(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComponentsAPIApi.componentsAPIViewComponents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ComponentsAPIApi - factory interface
 * @export
 */
export const ComponentsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComponentsAPIApiFp(configuration)
    return {
        /**
         * Returns the CASTware operator onboarding script. All parameters, including the  API token, are passed via environment variables at runtime.  The flat /v1/scripts/... path mirrors connect-and-enable-castai.sh.
         * @summary Get the CASTware operator onboarding script.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIGetCastwareOperatorOnboardingScript(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.componentsAPIGetCastwareOperatorOnboardingScript(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the component by name.  Used by the Castware Operator to validate the component CRD.
         * @summary Get a CASTware component by name.
         * @param {ComponentsAPIApiComponentsAPIGetComponentByNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIGetComponentByName(requestParameters: ComponentsAPIApiComponentsAPIGetComponentByNameRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Component> {
            return localVarFp.componentsAPIGetComponentByName(requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the status of a component for a cluster
         * @summary Get an installed CASTware component status.
         * @param {ComponentsAPIApiComponentsAPIGetComponentStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIGetComponentStatus(requestParameters: ComponentsAPIApiComponentsAPIGetComponentStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ComponentStatus> {
            return localVarFp.componentsAPIGetComponentStatus(requestParameters.organizationId, requestParameters.clusterId, requestParameters.componentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the CASTware operator install command ready to be run on user cluster
         * @param {ComponentsAPIApiComponentsAPIInstallOperatorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIInstallOperator(requestParameters: ComponentsAPIApiComponentsAPIInstallOperatorRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<InstallOperatorResponse> {
            return localVarFp.componentsAPIInstallOperator(requestParameters.providerType, options).then((request) => request(axios, basePath));
        },
        /**
         * Records the results of an action performed on a CASTware component.  Under the hood creates or updates an installed component.  Used by the Castware Operator to relay information about the result of an action.
         * @summary Record the result of an action performed on a CASTware component.
         * @param {ComponentsAPIApiComponentsAPIRecordActionResultRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIRecordActionResult(requestParameters: ComponentsAPIApiComponentsAPIRecordActionResultRequest, options?: RawAxiosRequestConfig): AxiosPromise<InstalledComponent> {
            return localVarFp.componentsAPIRecordActionResult(requestParameters.clusterId, requestParameters.componentActionResult, options).then((request) => request(axios, basePath));
        },
        /**
         * Runs an action on an installed component, if the operator is installed the action is run automatically,  otherwise a bash script to run the action manually is returned
         * @summary Run an action for a CASTware component.
         * @param {ComponentsAPIApiComponentsAPIRunComponentActionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIRunComponentAction(requestParameters: ComponentsAPIApiComponentsAPIRunComponentActionRequest, options?: RawAxiosRequestConfig): AxiosPromise<RunComponentActionResponse> {
            return localVarFp.componentsAPIRunComponentAction(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.componentActionParams, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates if a component installation can proceed based on operator RBAC permissions.
         * @summary Validate if component installation can proceed
         * @param {ComponentsAPIApiComponentsAPIValidateComponentInstallRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIValidateComponentInstall(requestParameters: ComponentsAPIApiComponentsAPIValidateComponentInstallRequest, options?: RawAxiosRequestConfig): AxiosPromise<ValidateComponentInstallResponse> {
            return localVarFp.componentsAPIValidateComponentInstall(requestParameters.clusterId, requestParameters.validateComponentInstallRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates if a component upgrade can proceed based on RBAC checksum changes.
         * @summary Validate if component upgrade can proceed
         * @param {ComponentsAPIApiComponentsAPIValidateComponentUpgradeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIValidateComponentUpgrade(requestParameters: ComponentsAPIApiComponentsAPIValidateComponentUpgradeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ValidateComponentUpgradeResponse> {
            return localVarFp.componentsAPIValidateComponentUpgrade(requestParameters.clusterId, requestParameters.validateComponentUpgradeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a view of a cluster combined with all CASTware components, for the given organization.  If a component is installed on the cluster, components insights are also provided.  It is a custom endpoint which combines clusters, components and installed components meant to be used by UI.
         * @summary View a cluster with installed CASTware components insights.
         * @param {ComponentsAPIApiComponentsAPIViewClusterComponentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIViewClusterComponents(requestParameters: ComponentsAPIApiComponentsAPIViewClusterComponentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ViewClusterComponentsResponse> {
            return localVarFp.componentsAPIViewClusterComponents(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a view of all clusters with CASTware components insights, for the given organization.  It is a custom endpoint which combines clusters, components and installed components meant to be used by UI.
         * @summary View clusters with CASTware components insights.
         * @param {ComponentsAPIApiComponentsAPIViewClustersComponentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIViewClustersComponents(requestParameters: ComponentsAPIApiComponentsAPIViewClustersComponentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ViewClustersComponentsResponse> {
            return localVarFp.componentsAPIViewClustersComponents(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a view of a CASTware component combined with all clusters, for the given organization.  If the component is installed on a cluster, components insights are also provided.  It is a custom endpoint which combines components and installed components meant to be used by UI.
         * @summary View a CASTware component with installed components insights.
         * @param {ComponentsAPIApiComponentsAPIViewComponentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIViewComponent(requestParameters: ComponentsAPIApiComponentsAPIViewComponentRequest, options?: RawAxiosRequestConfig): AxiosPromise<ViewComponentResponse> {
            return localVarFp.componentsAPIViewComponent(requestParameters.organizationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a view of all CASTware components with cluster insights, for the given organization.  It is a custom endpoint which combines components and installed components meant to be used by UI.
         * @summary View CASTware components with cluster insights.
         * @param {ComponentsAPIApiComponentsAPIViewComponentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsAPIViewComponents(requestParameters: ComponentsAPIApiComponentsAPIViewComponentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ViewComponentsResponse> {
            return localVarFp.componentsAPIViewComponents(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for componentsAPIGetComponentByName operation in ComponentsAPIApi.
 * @export
 * @interface ComponentsAPIApiComponentsAPIGetComponentByNameRequest
 */
export interface ComponentsAPIApiComponentsAPIGetComponentByNameRequest {
    /**
     * Filters components by name.
     * @type {string}
     * @memberof ComponentsAPIApiComponentsAPIGetComponentByName
     */
    readonly name?: string
}

/**
 * Request parameters for componentsAPIGetComponentStatus operation in ComponentsAPIApi.
 * @export
 * @interface ComponentsAPIApiComponentsAPIGetComponentStatusRequest
 */
export interface ComponentsAPIApiComponentsAPIGetComponentStatusRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof ComponentsAPIApiComponentsAPIGetComponentStatus
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof ComponentsAPIApiComponentsAPIGetComponentStatus
     */
    readonly clusterId: string

    /**
     * The ID of the component.
     * @type {string}
     * @memberof ComponentsAPIApiComponentsAPIGetComponentStatus
     */
    readonly componentId: string
}

/**
 * Request parameters for componentsAPIInstallOperator operation in ComponentsAPIApi.
 * @export
 * @interface ComponentsAPIApiComponentsAPIInstallOperatorRequest
 */
export interface ComponentsAPIApiComponentsAPIInstallOperatorRequest {
    /**
     * Provider of the cluster.
     * @type {'PROVIDER_TYPE_UNSPECIFIED' | 'GKE' | 'EKS' | 'AKS'}
     * @memberof ComponentsAPIApiComponentsAPIInstallOperator
     */
    readonly providerType?: ComponentsAPIInstallOperatorProviderTypeEnum
}

/**
 * Request parameters for componentsAPIRecordActionResult operation in ComponentsAPIApi.
 * @export
 * @interface ComponentsAPIApiComponentsAPIRecordActionResultRequest
 */
export interface ComponentsAPIApiComponentsAPIRecordActionResultRequest {
    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof ComponentsAPIApiComponentsAPIRecordActionResult
     */
    readonly clusterId: string

    /**
     * 
     * @type {ComponentActionResult}
     * @memberof ComponentsAPIApiComponentsAPIRecordActionResult
     */
    readonly componentActionResult: ComponentActionResult
}

/**
 * Request parameters for componentsAPIRunComponentAction operation in ComponentsAPIApi.
 * @export
 * @interface ComponentsAPIApiComponentsAPIRunComponentActionRequest
 */
export interface ComponentsAPIApiComponentsAPIRunComponentActionRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof ComponentsAPIApiComponentsAPIRunComponentAction
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof ComponentsAPIApiComponentsAPIRunComponentAction
     */
    readonly clusterId: string

    /**
     * The ID of the component.
     * @type {string}
     * @memberof ComponentsAPIApiComponentsAPIRunComponentAction
     */
    readonly id: string

    /**
     * 
     * @type {ComponentActionParams}
     * @memberof ComponentsAPIApiComponentsAPIRunComponentAction
     */
    readonly componentActionParams: ComponentActionParams
}

/**
 * Request parameters for componentsAPIValidateComponentInstall operation in ComponentsAPIApi.
 * @export
 * @interface ComponentsAPIApiComponentsAPIValidateComponentInstallRequest
 */
export interface ComponentsAPIApiComponentsAPIValidateComponentInstallRequest {
    /**
     * The cluster ID where the component will be installed.
     * @type {string}
     * @memberof ComponentsAPIApiComponentsAPIValidateComponentInstall
     */
    readonly clusterId: string

    /**
     * 
     * @type {ValidateComponentInstallRequest}
     * @memberof ComponentsAPIApiComponentsAPIValidateComponentInstall
     */
    readonly validateComponentInstallRequest: ValidateComponentInstallRequest
}

/**
 * Request parameters for componentsAPIValidateComponentUpgrade operation in ComponentsAPIApi.
 * @export
 * @interface ComponentsAPIApiComponentsAPIValidateComponentUpgradeRequest
 */
export interface ComponentsAPIApiComponentsAPIValidateComponentUpgradeRequest {
    /**
     * The cluster ID where the component is installed.
     * @type {string}
     * @memberof ComponentsAPIApiComponentsAPIValidateComponentUpgrade
     */
    readonly clusterId: string

    /**
     * 
     * @type {ValidateComponentUpgradeRequest}
     * @memberof ComponentsAPIApiComponentsAPIValidateComponentUpgrade
     */
    readonly validateComponentUpgradeRequest: ValidateComponentUpgradeRequest
}

/**
 * Request parameters for componentsAPIViewClusterComponents operation in ComponentsAPIApi.
 * @export
 * @interface ComponentsAPIApiComponentsAPIViewClusterComponentsRequest
 */
export interface ComponentsAPIApiComponentsAPIViewClusterComponentsRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof ComponentsAPIApiComponentsAPIViewClusterComponents
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof ComponentsAPIApiComponentsAPIViewClusterComponents
     */
    readonly clusterId: string
}

/**
 * Request parameters for componentsAPIViewClustersComponents operation in ComponentsAPIApi.
 * @export
 * @interface ComponentsAPIApiComponentsAPIViewClustersComponentsRequest
 */
export interface ComponentsAPIApiComponentsAPIViewClustersComponentsRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof ComponentsAPIApiComponentsAPIViewClustersComponents
     */
    readonly organizationId: string
}

/**
 * Request parameters for componentsAPIViewComponent operation in ComponentsAPIApi.
 * @export
 * @interface ComponentsAPIApiComponentsAPIViewComponentRequest
 */
export interface ComponentsAPIApiComponentsAPIViewComponentRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof ComponentsAPIApiComponentsAPIViewComponent
     */
    readonly organizationId: string

    /**
     * The ID of the component.
     * @type {string}
     * @memberof ComponentsAPIApiComponentsAPIViewComponent
     */
    readonly id: string
}

/**
 * Request parameters for componentsAPIViewComponents operation in ComponentsAPIApi.
 * @export
 * @interface ComponentsAPIApiComponentsAPIViewComponentsRequest
 */
export interface ComponentsAPIApiComponentsAPIViewComponentsRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof ComponentsAPIApiComponentsAPIViewComponents
     */
    readonly organizationId: string
}

/**
 * ComponentsAPIApi - object-oriented interface
 * @export
 * @class ComponentsAPIApi
 * @extends {BaseAPI}
 */
export class ComponentsAPIApi extends BaseAPI {
    /**
     * Returns the CASTware operator onboarding script. All parameters, including the  API token, are passed via environment variables at runtime.  The flat /v1/scripts/... path mirrors connect-and-enable-castai.sh.
     * @summary Get the CASTware operator onboarding script.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsAPIApi
     */
    public componentsAPIGetCastwareOperatorOnboardingScript(options?: RawAxiosRequestConfig) {
        return ComponentsAPIApiFp(this.configuration).componentsAPIGetCastwareOperatorOnboardingScript(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the component by name.  Used by the Castware Operator to validate the component CRD.
     * @summary Get a CASTware component by name.
     * @param {ComponentsAPIApiComponentsAPIGetComponentByNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsAPIApi
     */
    public componentsAPIGetComponentByName(requestParameters: ComponentsAPIApiComponentsAPIGetComponentByNameRequest = {}, options?: RawAxiosRequestConfig) {
        return ComponentsAPIApiFp(this.configuration).componentsAPIGetComponentByName(requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the status of a component for a cluster
     * @summary Get an installed CASTware component status.
     * @param {ComponentsAPIApiComponentsAPIGetComponentStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsAPIApi
     */
    public componentsAPIGetComponentStatus(requestParameters: ComponentsAPIApiComponentsAPIGetComponentStatusRequest, options?: RawAxiosRequestConfig) {
        return ComponentsAPIApiFp(this.configuration).componentsAPIGetComponentStatus(requestParameters.organizationId, requestParameters.clusterId, requestParameters.componentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the CASTware operator install command ready to be run on user cluster
     * @param {ComponentsAPIApiComponentsAPIInstallOperatorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsAPIApi
     */
    public componentsAPIInstallOperator(requestParameters: ComponentsAPIApiComponentsAPIInstallOperatorRequest = {}, options?: RawAxiosRequestConfig) {
        return ComponentsAPIApiFp(this.configuration).componentsAPIInstallOperator(requestParameters.providerType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Records the results of an action performed on a CASTware component.  Under the hood creates or updates an installed component.  Used by the Castware Operator to relay information about the result of an action.
     * @summary Record the result of an action performed on a CASTware component.
     * @param {ComponentsAPIApiComponentsAPIRecordActionResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsAPIApi
     */
    public componentsAPIRecordActionResult(requestParameters: ComponentsAPIApiComponentsAPIRecordActionResultRequest, options?: RawAxiosRequestConfig) {
        return ComponentsAPIApiFp(this.configuration).componentsAPIRecordActionResult(requestParameters.clusterId, requestParameters.componentActionResult, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Runs an action on an installed component, if the operator is installed the action is run automatically,  otherwise a bash script to run the action manually is returned
     * @summary Run an action for a CASTware component.
     * @param {ComponentsAPIApiComponentsAPIRunComponentActionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsAPIApi
     */
    public componentsAPIRunComponentAction(requestParameters: ComponentsAPIApiComponentsAPIRunComponentActionRequest, options?: RawAxiosRequestConfig) {
        return ComponentsAPIApiFp(this.configuration).componentsAPIRunComponentAction(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.componentActionParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates if a component installation can proceed based on operator RBAC permissions.
     * @summary Validate if component installation can proceed
     * @param {ComponentsAPIApiComponentsAPIValidateComponentInstallRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsAPIApi
     */
    public componentsAPIValidateComponentInstall(requestParameters: ComponentsAPIApiComponentsAPIValidateComponentInstallRequest, options?: RawAxiosRequestConfig) {
        return ComponentsAPIApiFp(this.configuration).componentsAPIValidateComponentInstall(requestParameters.clusterId, requestParameters.validateComponentInstallRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates if a component upgrade can proceed based on RBAC checksum changes.
     * @summary Validate if component upgrade can proceed
     * @param {ComponentsAPIApiComponentsAPIValidateComponentUpgradeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsAPIApi
     */
    public componentsAPIValidateComponentUpgrade(requestParameters: ComponentsAPIApiComponentsAPIValidateComponentUpgradeRequest, options?: RawAxiosRequestConfig) {
        return ComponentsAPIApiFp(this.configuration).componentsAPIValidateComponentUpgrade(requestParameters.clusterId, requestParameters.validateComponentUpgradeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a view of a cluster combined with all CASTware components, for the given organization.  If a component is installed on the cluster, components insights are also provided.  It is a custom endpoint which combines clusters, components and installed components meant to be used by UI.
     * @summary View a cluster with installed CASTware components insights.
     * @param {ComponentsAPIApiComponentsAPIViewClusterComponentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsAPIApi
     */
    public componentsAPIViewClusterComponents(requestParameters: ComponentsAPIApiComponentsAPIViewClusterComponentsRequest, options?: RawAxiosRequestConfig) {
        return ComponentsAPIApiFp(this.configuration).componentsAPIViewClusterComponents(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a view of all clusters with CASTware components insights, for the given organization.  It is a custom endpoint which combines clusters, components and installed components meant to be used by UI.
     * @summary View clusters with CASTware components insights.
     * @param {ComponentsAPIApiComponentsAPIViewClustersComponentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsAPIApi
     */
    public componentsAPIViewClustersComponents(requestParameters: ComponentsAPIApiComponentsAPIViewClustersComponentsRequest, options?: RawAxiosRequestConfig) {
        return ComponentsAPIApiFp(this.configuration).componentsAPIViewClustersComponents(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a view of a CASTware component combined with all clusters, for the given organization.  If the component is installed on a cluster, components insights are also provided.  It is a custom endpoint which combines components and installed components meant to be used by UI.
     * @summary View a CASTware component with installed components insights.
     * @param {ComponentsAPIApiComponentsAPIViewComponentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsAPIApi
     */
    public componentsAPIViewComponent(requestParameters: ComponentsAPIApiComponentsAPIViewComponentRequest, options?: RawAxiosRequestConfig) {
        return ComponentsAPIApiFp(this.configuration).componentsAPIViewComponent(requestParameters.organizationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a view of all CASTware components with cluster insights, for the given organization.  It is a custom endpoint which combines components and installed components meant to be used by UI.
     * @summary View CASTware components with cluster insights.
     * @param {ComponentsAPIApiComponentsAPIViewComponentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsAPIApi
     */
    public componentsAPIViewComponents(requestParameters: ComponentsAPIApiComponentsAPIViewComponentsRequest, options?: RawAxiosRequestConfig) {
        return ComponentsAPIApiFp(this.configuration).componentsAPIViewComponents(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ComponentsAPIInstallOperatorProviderTypeEnum = {
    PROVIDER_TYPE_UNSPECIFIED: 'PROVIDER_TYPE_UNSPECIFIED',
    GKE: 'GKE',
    EKS: 'EKS',
    AKS: 'AKS'
} as const;
export type ComponentsAPIInstallOperatorProviderTypeEnum = typeof ComponentsAPIInstallOperatorProviderTypeEnum[keyof typeof ComponentsAPIInstallOperatorProviderTypeEnum];
